import React from "react";

import { USER_TYPES } from "../../utils/userTypeConstants";
// Admin
import UserType from "../../views/auth/UserType";
import Dashboard from "../../views/admin/dashboard/Dashboard";
import AdminProfile from "../../views/admin/profile/index";
import AdminCompany from "../../views/admin/settings/Company";
import AdminGeneral from "../../views/admin/settings/General";
import AdminAppearance from "../../views/admin/settings/Appearance";
import AdminPayment from "../../views/admin/settings/Payment";
import AdminEmailNotification from "../../views/admin/settings/EmailNotification";
import AdminEmailTemplate from "../../views/admin/settings/EmailTemplate";
import AdminSMSNotification from "../../views/admin/settings/SMSNotification";
import AdminSMSTemplate from "../../views/admin/settings/SMSTemplate";
import AdminFrequentlyDiscount from "../../views/admin/settings/FrequentlyDiscount";
import Discount from "../../views/admin/settings/Discount";
import AdminFrontTooltips from "../../views/admin/settings/FrontTooltips";
import AdminFormFields from "../../views/admin/settings/FormFields";
import AdminSEO from "../../views/admin/settings/SEO";

import EventSettngs from "../../views/admin/settings/EventSettings";
import EmailSettngs from "../../views/admin/settings/EmailSettings";
import MyOctoLink from "../../views/admin/settings/MyOctoLink";
import Schedule from "../../views/admin/settings/Schedule/index";
import Vacation from "../../views/admin/settings/Vacation/index";
import AdminManageSubscription from "../../views/admin/subscription/index";
import PlanComparison from "../../views/admin/subscription/plan-comparison";
import CalendarIntegration from "../../views/admin/calendar-integrations";

import AdminScheduledEvents from "../../views/admin/schedule/scheduled-events";
import AdminMyCalendar from "../../views/admin/my-calendar/index";

import BookingHistory from "../../views/admin/settings/Staff/BookingHistory";
import StaffListing from "../../views/admin/settings/Staff/index";
import StaffAdd from "../../views/admin/settings/Staff/Create";
import StaffEdit from "../../views/admin/settings/Staff/Edit";
import CrmPayments from "../../views/admin/crm/payments/index";
import AdminCustomerListing from "../../views/admin/crm/customer/index";
//import MainPayment from "../views/admin/settings/CRM/Payments/MainPayment";

//import StaffPayment from "../views/admin/settings/CRM/Payments/Staff/StaffPayment";

import QuickSetupStepOne from "../../views/admin/quick-setup/step-one";
import QuickSetupStepTwo from "../../views/admin/quick-setup/step-two";
import QuickSetupStepThree from "../../views/admin/quick-setup/step-three";

//import ScheduleBackup from "../views/admin/settings/Schedule-backup/index";

// Staff
import StaffDashboard from "../../views/staff/dashboard/Dashboard";
import Calendar from "../../views/staff/Calendar";
import StaffSchedule from "../../views/staff/Schedule/index";
import StaffBookingHistory from "../../views/staff/BookingHistory/index";
import StaffCalendarIntegration from "../../views/staff/calendar-integrations";

// Super Admin
import SuperAdminDashboard from "../../views/super-admin/dashboard/Dashboard";
import SubcriberDetailsMain from "../../views/super-admin/SubscriberDetails/SubcriberDetailsMain";
import PlanManager from "../../views/super-admin/PlanManager/PlanManager";
import ReferalProgram from "../../views/super-admin/ReferalProgram/ReferalProgram";
import SuperAdminPromo from "../../views/super-admin/Promo/index";
import SystemSettings from "../../views/super-admin/Settings/SystemSettings";
import NotificationTemplates from "../../views/super-admin/NotificationTemplates/NotificationTemplates";
import FeatureRequests from "../../views/super-admin/FeatureRequests/index";
import Tooltip from "../../views/super-admin/tooltip/index";
import LaunchHealth from "../../views/super-admin/LaunchHealth/index";
import LaunchAnalytics from "../../views/super-admin/LaunchAnalytics/index";
import AlertSettings from "../../views/super-admin/AlertSettings/index";
import SMSPackages from "../../views/super-admin/SMSPackages/SMSPackages";
import SuperAdminStaffCalendar from "../../views/super-admin/StaffCalendar";

// Customer
import CustomerDashboard from "../../views/customer/dashboard/Dashboard";

// Events

import EventTypeList from "../../views/events/list-events-types";
// Old event wizard pages — kept imported (not routed) since the Event Builder cutover
// (docs/event-builder-redesign-plan.md Part 10). Rollback = point the five `/admin/events/create*`
// entries below back at these components.
// eslint-disable-next-line no-unused-vars
import AddNewEvent from "../../views/events/add-new-event";
// eslint-disable-next-line no-unused-vars
import AddNewEventDetails from "../../views/events/add-new-event-details";
// eslint-disable-next-line no-unused-vars
import AddNewEventAvailability from "../../views/events/add-new-event-availbility";
// eslint-disable-next-line no-unused-vars
import AddNewEventAdvanced from "../../views/events/add-new-event-advanced";
import AddAdHocComponent from "../../views/events/add-ad-hoc-event";
import EventSuccessPage from "../../views/events/event-success-page";
import ListEventsView from "../../views/events/list-view-events";
import EventBuilderPage from "../../views/events/builder/EventBuilderPage";
import RedirectToBuilder from "../../views/events/builder/RedirectToBuilder";
//import MyCalendar from "../views/admin/settings/MyCalender/MyCalendar";

import AdminRefferalList from "../../views/admin/settings/AdminRefferal/AdminRefferalList";
import NotificationSettingsTemplate from "../../components/Notifications/NotificationSettings";
import AllNotifications from "../../components/Notifications/AllNotifications";
import Notifications from "../../views/admin/notifications";
import NotificationSettings from "../../views/admin/notifications/settings";
import EventSummary from "../../components/EventSummary/EventSummary";

import AdminEventSummary from "../../views/events/event-summary";

//import CustomCalendar from "../views/admin/my-calendar-backup/calendar-view";
import TooltipManagment from "../../components/TooltipManage/TooltipManagment";
import CancelEvent from "../../views/events/CancelEvent";
import EventNotavail from "../../views/events/EventNotavail";
import AllIntegrations from "../../views/admin/all-integrations/index";
import Integrations from "../../views/integrations/index";
import ZoomIntegration from "../../views/integrations/zoom/index";
import GoogleMeetIntegration from "../../views/integrations/meet/index";
import MicrosoftTeamsIntegration from "../../views/integrations/ms-teams/index";
import StripeIntegration from "../../views/integrations/stripe";
import PaypalIntegration from "../../views/integrations/paypal";
//import NewIntegrations from "../../views/admin/new-integration/index";



export { USER_TYPES } from "../../utils/userTypeConstants";

const routes = [
  {
    component: UserType,
    exact: true,
    path: "/user-type",
    userType: USER_TYPES.admin,
  },
  // admin routes
  {
    component: Dashboard,
    exact: true,
    path: "/admin/dashboard",
    userType: USER_TYPES.admin,
  },
  // admin routes
  {
    component: AdminEventSummary,
    exact: true,
    path: "/admin/event-summary/:id",
    userType: USER_TYPES.admin,
  },
  {
    component: EventSummary,
    exact: true,
    path: "/admin/event-summary",
    userType: USER_TYPES.admin,
  },
  {
    component: TooltipManagment,
    exact: true,
    path: "/admin/tooltip-managment",
    userType: USER_TYPES.admin,
  },
  {
    component: Tooltip,
    exact: true,
    path: "/admin/tooltip",
    userType: USER_TYPES.admin,
  },
  {
    //component: React.lazy(() => import("../views/admin/profile/Profile")),
    component: AdminProfile,
    exact: true,
    path: "/admin/profile",
    userType: USER_TYPES.admin,
  },
  {
    //component: React.lazy(() => import("../views/admin/settings/Company")),
    component: AdminCompany,
    exact: true,
    path: "/admin/settings/company",
    userType: USER_TYPES.admin,
  },
  {
    //component: React.lazy(() => import("../views/admin/settings/General")),
    component: AdminGeneral,
    exact: true,
    path: "/admin/settings/general",
    userType: USER_TYPES.admin,
  },
  {
    //component: React.lazy(() => import("../views/admin/settings/Appearance")),
    component: AdminAppearance,
    exact: true,
    path: "/admin/settings/appearance",
    userType: USER_TYPES.admin,
  },
  {
    //component: React.lazy(() => import("../views/admin/settings/Payment")),
    component: AdminPayment,
    exact: true,
    path: "/admin/settings/payment",
    userType: USER_TYPES.admin,
  },
  {
    component: AdminEmailNotification,
    //component: React.lazy(() =>
    //  import("../views/admin/settings/EmailNotification")
    //),
    exact: true,
    path: "/admin/settings/email-notifications",
    userType: USER_TYPES.admin,
  },
  {
    //component: React.lazy(() =>
    //  import("../views/admin/settings/EmailTemplate")
    //),
    component: AdminEmailTemplate,
    exact: true,
    path: "/admin/settings/email-template",
    userType: USER_TYPES.admin,
  },
  {
    //component: React.lazy(() =>
    //  import("../views/admin/settings/SMSNotification")
    //),
    component: AdminSMSNotification,
    exact: true,
    path: "/admin/settings/sms-notifications",
    userType: USER_TYPES.admin,
  },
  {
    //component: React.lazy(() => import("../views/admin/settings/SMSTemplate")),
    component: AdminSMSTemplate,
    exact: true,
    path: "/admin/settings/sms-template",
    userType: USER_TYPES.admin,
  },
  {
    //component: React.lazy(() =>
    //  import("../views/admin/settings/FrequentlyDiscount")
    // ),
    component: AdminFrequentlyDiscount,
    exact: true,
    path: "/admin/settings/frequently-discount",
    userType: USER_TYPES.admin,
  },
  {
    //component: React.lazy(() => import("../views/admin/settings/Promocode")),
    component: Discount,
    exact: true,
    path: "/admin/settings/discounts",
    userType: USER_TYPES.admin,
  },
  {
    //component: React.lazy(() => import("../views/admin/settings/Promocode")),
    component: CalendarIntegration,
    exact: true,
    path: "/admin/calendar-integration",
    userType: USER_TYPES.admin,
  },

  {
    //component: React.lazy(() =>
    //  import("../views/admin/settings/FrontTooltips")
    // ),
    component: AdminFrontTooltips,
    exact: true,
    path: "/admin/settings/front-tooltips",
    userType: USER_TYPES.admin,
  },
  {
    component: React.lazy(() => import("../../views/admin/settings/FormFields")),
    exact: true,
    path: "/admin/settings/form-fields",
    userType: USER_TYPES.admin,
  },
  {
    //component: React.lazy(() =>
    //  import("../views/admin/settings/RecurrenceBooking")
    //),
    component: AdminFormFields,
    exact: true,
    path: "/admin/settings/recurrence-booking",
    userType: USER_TYPES.admin,
  },

  {
    component: AdminManageSubscription,
    exact: true,
    path: "/admin/manage-subscription",
    userType: USER_TYPES.admin,
  },

  {
    component: PlanComparison,
    exact: true,
    path: "/admin/plan-comparison",
    userType: USER_TYPES.admin,
  },

  {
    component: QuickSetupStepOne,
    exact: true,
    path: "/admin/quick-setup-step-one",
    userType: USER_TYPES.admin,
  },

  {
    component: QuickSetupStepTwo,
    exact: true,
    path: "/admin/quick-setup-step-two",
    userType: USER_TYPES.admin,
  },

  {
    component: QuickSetupStepThree,
    exact: true,
    path: "/admin/quick-setup-step-three",
    userType: USER_TYPES.admin,
  },

  {
    component: AdminScheduledEvents,
    exact: true,
    path: "/admin/scheduled-events",
    userType: USER_TYPES.admin,
  },
  {
    //component: React.lazy(() => import("../views/admin/settings/SEO")),
    component: AdminSEO,
    exact: true,
    path: "/admin/settings/seo",
    userType: USER_TYPES.admin,
  },
  /*
  {
    component: Integrations,
    exact: true,
    path: "/admin/integrations",
    userType: USER_TYPES.admin,
  },
  */
  /*
          {
            component: Events,
            exact: true,
            path: "/admin/my-bookings",
            userType: USER_TYPES.admin,
          },
          */

  // staff routes
  {
    component: StaffDashboard,
    exact: true,
    path: "/staff/dashboard",
    userType: USER_TYPES.staff,
  },

  // super admin routes
  {
    component: SuperAdminDashboard,
    exact: true,
    path: "/super-admin/dashboard",
    userType: USER_TYPES.superAdmin,
  },

  {
    component: SubcriberDetailsMain,
    exact: true,
    path: "/super-admin/subscriber",
    userType: USER_TYPES.superAdmin,
  },

  {
    component: PlanManager,
    exact: true,
    path: "/super-admin/plan-manager",
    userType: USER_TYPES.superAdmin,
  },

  {
    component: ReferalProgram,
    exact: true,
    path: "/super-admin/referral-program",
    userType: USER_TYPES.superAdmin,
  },

  {
    component: SuperAdminPromo,
    exact: true,
    path: "/super-admin/promos",
    userType: USER_TYPES.superAdmin,
  },

  {
    component: SystemSettings,
    exact: true,
    path: "/super-admin/settings",
    userType: USER_TYPES.superAdmin,
  },

  {
    component: NotificationTemplates,
    exact: true,
    path: "/super-admin/notification-templates",
    userType: USER_TYPES.superAdmin,
  },

  {
    component: FeatureRequests,
    exact: true,
    path: "/super-admin/feature-requests",
    userType: USER_TYPES.superAdmin,
  },
  {
    component: LaunchHealth,
    exact: true,
    path: "/super-admin/launch-health",
    userType: USER_TYPES.superAdmin,
  },
  {
    component: LaunchAnalytics,
    exact: true,
    path: "/super-admin/launch-analytics",
    userType: USER_TYPES.superAdmin,
  },
  {
    component: AlertSettings,
    exact: true,
    path: "/super-admin/alert-settings",
    userType: USER_TYPES.superAdmin,
  },

  {
    component: SMSPackages,
    exact: true,
    path: "/super-admin/sms-packages",
    userType: USER_TYPES.superAdmin,
  },
  {
    component: SuperAdminStaffCalendar,
    exact: true,
    path: "/super-admin/staff-calendar",
    userType: USER_TYPES.superAdmin,
  },

  // customer routes
  {
    component: CustomerDashboard,
    exact: true,
    path: "/customer/dashboard",
    userType: USER_TYPES.customer,
  },
  {
    component: EventSettngs,
    exact: true,
    path: "/admin/settings/events",
    userType: USER_TYPES.admin,
  },
  {
    component: EmailSettngs,
    exact: true,
    path: "/admin/settings/email-settings",
    userType: USER_TYPES.admin,
  },
  {
    component: MyOctoLink,
    exact: true,
    path: "/admin/settings/my-octo-link",
    userType: USER_TYPES.admin,
  },
  {
    component: AdminMyCalendar,
    exact: true,
    path: "/admin/my-calendar",
    userType: USER_TYPES.admin,
  },
  {
    component: Schedule,
    //component: ScheduleBackup,
    exact: true,
    path: "/admin/settings/schedule",
    userType: USER_TYPES.admin,
  },
  {
    component: Vacation,
    exact: true,
    path: "/admin/vacation",
    userType: USER_TYPES.admin,
  },
  {
    component: BookingHistory,
    exact: true,
    path: "/admin/staff/booking-history",
    userType: USER_TYPES.admin,
  },
  /*
        {
          component: CustomCalendar,
          exact: true,
          path: "/admin/custom-calendar",
          userType: USER_TYPES.admin,
        },
        */
  /*
        {
          component: AdminStaffSchedule,
          exact: true,
          path: "/admin/staff/schedule",
          userType: USER_TYPES.admin,
        },
        */

  {
    component: StaffListing,
    exact: true,
    path: "/admin/staff",
    userType: USER_TYPES.admin,
  },
  {
    component: StaffAdd,
    exact: true,
    path: "/admin/staff/create",
    userType: USER_TYPES.admin,
  },
  {
    component: StaffEdit,
    exact: true,
    path: "/admin/staff/edit/:id",
    userType: USER_TYPES.admin,
  },

  /*
          {
            component: DirectoryInformationView,
            exact: true,
            path: "/admin/settings/staff/directory-information/view/:id",
            userType: USER_TYPES.admin,
          },
          {
            component: DirectoryInformationEdit,
            exact: true,
            path: "/admin/settings/staff/directory-information/edit/:id",
            userType: USER_TYPES.admin,
          },
          */
  /*
          {
            component: CrmMain,
            exact: true,
            path: "/admin/settings/crm",
            userType: USER_TYPES.admin,
          },
          */

  {
    component: AdminCustomerListing,
    exact: true,
    path: "/admin/customer",
    userType: USER_TYPES.admin,
  },
  {
    component: CrmPayments,
    exact: true,
    path: "/admin/booking-history",
    userType: USER_TYPES.admin,
  },

  {
    //component: React.lazy(() => import("../views/admin/profile/Profile")),
    component: AdminProfile,
    exact: true,
    path: "/customer/profile",
    userType: USER_TYPES.customer,
  },
  {
    //component: React.lazy(() => import("../views/admin/profile/Profile")),
    component: AdminProfile,
    exact: true,
    path: "/staff/profile",
    userType: USER_TYPES.staff,
  },

  {
    component: StaffSchedule,
    exact: true,
    path: "/staff/schedule",
    userType: USER_TYPES.staff,
  },
  {
    //component: React.lazy(() => import("../views/admin/profile/Profile")),
    component: StaffBookingHistory,
    exact: true,
    path: "/staff/booking-history",
    userType: USER_TYPES.staff,
  },

  /*
        {
          //component: React.lazy(() => import("../views/admin/profile/Profile")),
          component: StaffAppointment,
          exact: true,
          path: "/staff/booking",
          userType: USER_TYPES.staff,
        },
        */
  /*
        {
          //component: React.lazy(() => import("../views/admin/profile/Profile")),
          component: StaffPayment,
          exact: true,
          path: "/staff/payment",
          userType: USER_TYPES.staff,
        },
        */
  {
    //component: React.lazy(() => import("../views/admin/profile/Profile")),
    component: Calendar,
    exact: true,
    path: "/staff/calendar",
    userType: USER_TYPES.staff,
  },
  {
    component: StaffCalendarIntegration,
    exact: true,
    path: "/staff/calendar-integration",
    userType: USER_TYPES.staff,
  },
  {
    component: EventTypeList,
    exact: true,
    path: "/admin/events/create/list",
    userType: USER_TYPES.admin,
  },

  // Event Builder cutover (plan Part 10 / Phase 9): the five old wizard URLs redirect to the
  // builder so no caller (picker, list, summary, mobile bar) needs editing. `?type=` is kept;
  // step-2/4 → ?section=invitee, step-3 → ?section=availability.
  {
    component: RedirectToBuilder,
    exact: true,
    path: "/admin/events/create",
    userType: USER_TYPES.admin,
  },
  {
    component: RedirectToBuilder,
    exact: true,
    path: "/admin/events/:id/create",
    userType: USER_TYPES.admin,
  },
  {
    component: RedirectToBuilder,
    exact: true,
    path: "/admin/events/create/:id/step-2",
    userType: USER_TYPES.admin,
  },
  {
    component: RedirectToBuilder,
    exact: true,
    path: "/admin/events/create/:id/step-3",
    userType: USER_TYPES.admin,
  },
  {
    component: RedirectToBuilder,
    exact: true,
    path: "/admin/events/create/:id/step-4",
    userType: USER_TYPES.admin,
  },

  {
    component: AddAdHocComponent,
    exact: true,
    path: "/admin/events/create/ad-hoc",
    userType: USER_TYPES.admin,
  },

  {
    component: AddAdHocComponent,
    exact: true,
    path: "/admin/events/create/:id/ad-hoc",
    userType: USER_TYPES.admin,
  },

  {
    component: EventSuccessPage,
    exact: true,
    path: "/admin/events/success",
    userType: USER_TYPES.admin,
  },
  {
    component: ListEventsView,
    exact: true,
    path: "/admin/events/list",
    userType: USER_TYPES.admin,
  },

  // Event Builder (redesign) — new event / edit event. See docs/event-builder-redesign-plan.md 3.1
  {
    component: EventBuilderPage,
    exact: true,
    path: "/admin/events/builder",
    userType: USER_TYPES.admin,
  },
  {
    component: EventBuilderPage,
    exact: true,
    path: "/admin/events/builder/:id",
    userType: USER_TYPES.admin,
  },

  {
    //component: React.lazy(() =>
    //  import("../views/admin/settings/SMSNotification")
    //),
    component: AdminRefferalList,
    exact: true,
    path: "/admin/settings/admin-refferal",
    userType: USER_TYPES.admin,
  },
  {
    //component: React.lazy(() => import("../views/admin/profile/Profile")),
    component: NotificationSettings,
    exact: true,
    path: "/admin/notification-settings",
    userType: USER_TYPES.admin,
  },
  // {
  //   component: NotificationSettingsTemplate,
  //   exact: true,
  //   path: "/admin/notification-settings-template",
  //   userType: USER_TYPES.admin,
  // },
  {
    component: Notifications,
    exact: true,
    path: "/admin/notifications",
    userType: USER_TYPES.admin,
  },
  // {
  //   component: AllNotifications,
  //   exact: true,
  //   path: "/admin/all-notifications",
  //   userType: USER_TYPES.admin,
  // },
  {
    //component: React.lazy(() => import("../views/admin/profile/Profile")),
    component: AdminProfile,
    exact: true,
    path: "/super-admin/profile",
    userType: USER_TYPES.superAdmin,
  },
  {
    //component: React.lazy(() => import("../views/admin/profile/Profile")),
    component: CancelEvent,
    exact: true,
    path: "/admin/cancel-event",
    userType: USER_TYPES.admin,
  },
  {
    //component: React.lazy(() => import("../views/admin/profile/Profile")),
    component: AllIntegrations,
    exact: true,
    path: "/admin/all-integrations",
    userType: USER_TYPES.admin,
  },
  {
    component: Integrations,
    exact: true,
    path: "/integrations",
    userType: USER_TYPES.admin,
  },
  {
    component: ZoomIntegration,
    exact: true,
    path: "/integrations/zoom",
    userType: USER_TYPES.admin,
  },
  {
    component: GoogleMeetIntegration,
    exact: true,
    path: "/integrations/meet",
    userType: USER_TYPES.admin,
  },
  {
    component: MicrosoftTeamsIntegration,
    exact: true,
    path: "/integrations/ms-teams",
    userType: USER_TYPES.admin,
  },
  {
    component: StripeIntegration,
    exact: true,
    path: "/integrations/stripe",
    userType: USER_TYPES.admin,
  },
  {
    component: PaypalIntegration,
    exact: true,
    path: "/integrations/paypal",
    userType: USER_TYPES.admin,
  },
  // {
  //   //component: React.lazy(() => import("../views/admin/profile/Profile")),
  //   component: NewIntegrations,
  //   exact: true,
  //   path: "/admin/new-integrations",
  //   userType: USER_TYPES.admin,
  // },
  {
    component: EventNotavail,
    exact: true,
    path: "/admin/event-no-avail",
    userType: USER_TYPES.admin,
  }
];

export default routes;
